import React, { useContext, useState } from "react";
import { Box, Heading, HStack, Text, VStack } from "native-base";
import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-number-input";
import es from "react-phone-number-input/locale/es.json";
import styles from "./styles.module.css";
import colors from "../../../constants/colors";
import API, { source } from "../../../api";
import { StateContext, StatusContext } from "../../../contexts";
import constants from "../../../constants";
import { useNavigate } from "react-router-dom";
import routes from "../../../routes";

function SignUpAgencyPage() {
  const navigate = useNavigate();
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phoneExtension, setPhoneExtension] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onRegister = async () => {
    setIsLoading(true);
    try {
      const {
        data: { jwt, user: _user },
      } = await API().post("/auth/local/register", {
        username: email,
        email,
        password: "123456",
        firstName,
        lastName,
        phone,
        phoneExtension,
        isVendor: true,
        source,
      });
      await API(jwt).post("/agencies", {
        data: {
          name,
          managerFirstName: firstName,
          managerLastName: lastName,
          users: [_user.id],
        },
      });
      await state.refreshUser(jwt);
      localStorage.setItem(constants.state.JWT, jwt);
      state.updateJwt(jwt);
      state.updateIsLoggedIn(true);
      status.updateSuccessMessage(
        "¡Gracias por registrarte! Por favor, verifica tu cuenta a través del enlace que te enviamos por correo electrónico. ¡Bienvenido!",
      );
      navigate(routes.agencyExperienceCreation);
    } catch (error) {
      status.updateErrorMessage(error);
    }
    setIsLoading(false);
  };

  return (
    <VStack paddingTop={50} alignItems="center">
      <Helmet>
        <title>Registro - Empresa</title>
      </Helmet>
      <Heading
        color={colors.secondary}
        fontSize="2xl"
        textAlign="center"
        marginBottom={7}>
        Registrarse como empresa
      </Heading>
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          onRegister();
        }}>
        <VStack
          backgroundColor={colors.white}
          padding={10}
          borderRadius={5}
          space={5}>
          <Heading color={colors.secondary} fontSize="xl">
            Información de contacto
          </Heading>
          <HStack marginTop={5} space={5}>
            <label className={styles.input}>
              <Text>Nombre</Text>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
            <label className={styles.input}>
              <Text>Apellido</Text>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
          </HStack>
          <HStack space={5}>
            <label className={styles.input}>
              <Text>Número de teléfono</Text>
              <PhoneInput
                labels={es}
                defaultCountry="MX"
                disabled={isLoading}
                value={phone}
                onChange={setPhone}
                required
              />
            </label>
            <label className={styles.input}>
              <Text>Extensión (opcional)</Text>
              <input
                type="tel"
                value={phoneExtension}
                onChange={(e) =>
                  setPhoneExtension(e.target.value.replace(/[^0-9]/g, ""))
                }
                disabled={isLoading}
              />
            </label>
          </HStack>
          <HStack space={5}>
            <label className={styles.input}>
              <Text>Correo electrónico</Text>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
          </HStack>
          <HStack space={5}>
            <label className={styles.input}>
              <Text>Nombre comercial de la empresa</Text>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                disabled={isLoading}
              />
            </label>
          </HStack>
        </VStack>
        <button disabled={isLoading}>
          <Box
            backgroundColor={colors.primary}
            paddingX={20}
            paddingY={2}
            borderRadius="full">
            <Text color={colors.white}>Continuar</Text>
          </Box>
        </button>
      </form>
    </VStack>
  );
}

export default SignUpAgencyPage;
